export default {
  name: 'PageHeading',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
};